import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import dotenv from 'dotenv';
import Amplify from 'aws-amplify';
import { MutationCache, QueryCache, QueryClient, QueryClientProvider } from 'react-query';
import { ThemeProvider } from '@material-ui/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import Paper from '@material-ui/core/Paper';
import { ReactQueryDevtools } from 'react-query/devtools';
import awsAuthConfig from 'aws-exports';
import { LoaderProvider } from 'LoaderCtx';
import App from './App';
import { getTheme } from './theme';
import { AppProvider } from './AppCtx';
import AlertsArea from './components/AlertsArea';
import { AuthProvider } from './AuthCtx';
import { DialogProvider } from './dialog-provider-hooks';

dotenv.config();
Amplify.configure(awsAuthConfig);

const Root = () => {
  // Create a client
  const queryClient = new QueryClient(
    {
      defaultOptions: {
        queries: {
          retry: 0,
          useErrorBoundary: true,
        },
      },
      queryCache: new QueryCache({
        onError: (error, query) => {
          console.debug('Error on Query:', query?.queryKey);
        },
      }),
      mutationCache: new MutationCache({
        onError: (error, mutation) => {
          console.debug('Error on Mutation:', mutation?.mutationKey);
        },
      }),
    },
  );

  const theme = getTheme();

  return (
    <>
      <QueryClientProvider client={ queryClient }>
        <ThemeProvider theme={ theme }>
          {/* CssBaseline kickstart an elegant, consistent, and simple baseline to build upon. */}
          <CssBaseline />
          <LoaderProvider>
            <AuthProvider>
              <AppProvider>
                <Paper id='App' elevation={ 0 }>
                  <DialogProvider>
                    <App />
                  </DialogProvider>
                </Paper>
                <AlertsArea />
              </AppProvider>
            </AuthProvider>
          </LoaderProvider>
        </ThemeProvider>
        <ReactQueryDevtools initialIsOpen={ false } />
      </QueryClientProvider>
    </>
  );
};

ReactDOM.render(<Root />, document.getElementById('root'));

